module.exports = __webpack_public_path__ + "static/media/Map.f712c9d1.png";